import React from "react";
import T from "prop-types";

import Buttons from "2g-buttons";
import { Icons } from "2g-icons";
import { Card } from "2g-cards";

import { PATHS } from "b2b/constants";
import { DateTime } from "b2b/renderers";
import Authorized from "b2b/components/auth";

import provozniInformaceType from "./provozniInformaceType";
import useCard from "./hooks/useCard";

function ProvozniInformaceCard({ data, onDeleteSuccess, editable, deletable }) {
  const { imageSrc, nazev, popis, onDetail, onEdit, onDelete } = useCard({
    data,
    onDeleteSuccess
  });

  return (
    <Card
      imageSrc={imageSrc || `exact:${PATHS.IMAGES.noImage()}`}
      imageSrcError={`exact:${PATHS.IMAGES.noImage()}`}
      label={nazev}
      description={<DateTime val={data?.datumUprava} />}
      onClick={onDetail}
      actions={
        <>
          {editable && (
            <Authorized roles={["admin", "vuz_spravce", "vuz_edit"]}>
              <Buttons.Success inverse onClick={onEdit}>
                <Icons.Edit />
              </Buttons.Success>
            </Authorized>
          )}
          {deletable && (
            <Authorized roles={["admin", "vuz_spravce", "vuz_edit"]}>
              <Buttons.Danger inverse onClick={onDelete}>
                <Icons.Delete />
              </Buttons.Danger>
            </Authorized>
          )}
          <Buttons.Info inverse>
            <Icons.ArrowDouble />
          </Buttons.Info>
        </>
      }
    >
      {popis}
    </Card>
  );
}

ProvozniInformaceCard.propTypes = {
  data: provozniInformaceType,
  onDeleteSuccess: T.func,
  editable: T.bool,
  deletable: T.bool
};

export default React.memo(ProvozniInformaceCard);
